import { YTDRollUp } from './YTDRollUp';

export class BigObjectiveRollUp extends YTDRollUp {
    public bigObjective: string;
    public countries: { [country: string]: YTDRollUp } = {};
}
